import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import classes from './style.module.css';
import AbsoluteLoading from 'components/LoadingMap/AbsoluteLoading';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ViewPDF = ({ url, setWidthSameDocument, pageProps }) => {
  const ref = useRef(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (count > 0) {
      setTimeout(() => {
        if (ref.current && setWidthSameDocument) {
          setWidthSameDocument(
            ref.current?.pages?.current[0]?.offsetWidth || '100%',
          );
        }
      }, 200);
    }
  }, [count]);

  return (
    <Document
      file={url}
      // loading={<AbsoluteLoading />}
      error={<AbsoluteLoading />}
      noData={<AbsoluteLoading />}
      className={classes.document}
      onLoadSuccess={() => {
        setCount((prev) => prev + 1);
      }}
      ref={ref}
    >
      <Page
        pageNumber={1}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        className={
          pageProps?.width ? classes['custom-width-page'] : classes.page
        }
        {...pageProps}
      />
    </Document>
  );
};

export default ViewPDF;
